export const myAccountConfig = {
  company: 'Royal Kennel Club Pet Insurance',
  referenceName: 'a Royal Kennel Club',
  seoTitleSuffix: '| My Account | Royal Kennel Club Pet Insurance',
  partnerIdName: 'Membership Number',
  partnerLoginInfo: 'For breeders',
  breederLoginInfo: 'For Royal Kennel Club Breeder Club members',
  vetLoginInfo: 'For veterinary practices',
  referAFriendUrl: 'https://clk.omgt1.com/?PID=35329&AID=2353495',
  petReferenceName: 'Dog',
  enableMarketingMaterials: false,
  enablePartnerLogin: true,
  showAddPetCard: true,
  termsReferenceName: 'Terms and Conditions',
  marketingReferenceName: 'marketing preferences',
  paymentDetailSupportMessage: false,
  enableUpdateMarketingPreferences: true,
  agriaAppReferenceName: 'Agria app',
  logoutRedirectUrl: '/',
} as const;
